const Marionette = require('backbone.marionette');
const templates = require('../templates');
const parameters = require('../data/parameters.js');

const numberOfWeeks = parameters.get('weeks_to_display');
const time = require('../data/time.js');
const app = require('../app.js');

const dateHeaderChildView = Marionette.ItemView.extend({
  template: templates.header_dates,
  serializeData() {
    return {
      firstDay: this.displayDate(this.model.get('firstDay')),
      secondDay: this.displayDate(this.model.get('secondDay')),
      thirdDay: this.displayDate(this.model.get('thirdDay')),
      fourthDay: this.displayDate(this.model.get('fourthDay')),
      fifthDay: this.displayDate(this.model.get('fifthDay')),
      sixthDay: this.displayDate(this.model.get('sixthDay')),
      seventhDay: this.displayDate(this.model.get('seventhDay'))
    };
  },
  displayDate(Day) {
    if (Day.date() === 1) {
      this.day = '1er';
    } else {
      this.day = Day.date();
    }

    this.month = Day._locale._months[Day.month()];

    return `${this.day} ${this.month}`;
  }
});

module.exports = Marionette.CompositeView.extend({
  template: templates.header_dates_groups,
  initialize() {
    this.listenTo(app.vent, 'returnToDefault', this.returnToDefault);
  },
  returnToDefault() {
    const currentWeek = time.get('currentWeek');
    time.set('currentWeek', 0);

    if (currentWeek > 0) {
      let i = 0;
      for (i = 0; i < currentWeek; i++) {
        this.displayPrevWeek();
      }
    }
    setTimeout(() => {
      app.vent.trigger('displayChangeWeek');
    }, 200);
  },
  childView: dateHeaderChildView,
  childViewContainer: '.owl-carousel',
  events: {
    "click img[class='plg_left_arrow']": 'displayPrevWeek',
    "click img[class='plg_right_arrow']": 'displayNextWeek'
  },
  displayPrevWeek() {
    app.vent.trigger('displayPrevWeekAnim');
  },
  displayNextWeek() {
    app.vent.trigger('displayNextWeekAnim');
  },
  serializeData() {
    if (time.get('currentWeek') > 0) {
      this.leftArrowClass = '';
    } else {
      this.leftArrowClass = ' disabled';
    }
    if (time.get('currentWeek') < numberOfWeeks - 1) {
      this.rightArrowClass = '';
    } else {
      this.rightArrowClass = ' disabled';
    }

    return {
      leftArrowClass: this.leftArrowClass,
      rightArrowClass: this.rightArrowClass
    };
  },
  onRender() {
    this.$('.owl-carousel').owlCarousel({
      nav: false,
      items: 1,
      smartSpeed: 500
    });
    this.$('.owl-carousel').on('changed.owl.carousel', event => {
      time.set('currentWeek', event.item.index);
      app.vent.trigger('displayChangeWeek');
      app.vent.trigger('animateOverflowBookings');
    });
    app.vent.trigger('animateOverflowBookings');
  }
});



// WEBPACK FOOTER //
// ./src/views/header_dates.js